import { ProductsListItem } from './ProductsListItem';

export default ProductsListItem;
